import './button.css'
import { useCallback, useState } from 'react'
import { ShareIcon } from '../icons/shareIcon'
import { useProject } from '../project/hook'
import { useTranslator } from '../translator/hook'
import { Breakpoint, useBreakpoint } from '../breakpoints'
import { Tooltip } from '../tooltip'
import { useTooltip } from '../tooltipHook'
import { LoadingBox } from '../loading/loadingBox'
import { ShareModal } from '../sharing/shareModal'

export const ShareButton = () => {
  const { t } = useTranslator()
  const { updateProjectShareStatus, isPublic } = useProject()
  const isWide = !useBreakpoint(Breakpoint.phase1)
  const { getReferenceProps, refs, tooltipProps } = useTooltip()
  const [isLoading, setIsLoading] = useState(false)
  const [showShareModal, setShowShareModal] = useState(false)

  const handleClick = useCallback(async () => {
    setIsLoading(true)
    try {
      const result = await updateProjectShareStatus(!isPublic)
      setShowShareModal(result)
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }, [isPublic, updateProjectShareStatus])

  return (
    <>
      <LoadingBox loading={isLoading} />

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
      />

      <div
        className={isPublic ? 'sharing-small-button' : 'share-small-button'}
        onClick={handleClick}
        ref={refs.setReference}
        {...getReferenceProps()}
      >
        <ShareIcon style={{ verticalAlign: 'middle' }} />
        {isWide && (
          <span style={{ marginLeft: '5px' }}>
            {isPublic ? t('sharing') : t('to_share')}
          </span>
        )}
        <Tooltip
          {...tooltipProps}
          className="share-button-tooltip"
          disabled={isWide}
        >
          {isPublic ? t('sharing') : t('to_share')}
        </Tooltip>
      </div>
    </>
  )
}
